import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableCell, TableRow } from '@material-ui/core';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
    backgroundColor: 'lightgray',
  },
});

export const MedicamentoItem = (props) => {
  const { item } = props;
  const classes = useRowStyles();

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell component="th" scope="row">
          {item.medicamento?.idMedicamento}
        </TableCell>
        <TableCell>{item.medicamento?.presentacion}</TableCell>
        <TableCell>{item.medicamento?.laboratorio}</TableCell>
        <TableCell>{item.medicamento?.nombre}</TableCell>
        <TableCell>{item.medicamento?.drogas}</TableCell>
        <TableCell align="right">{item.cantidad}</TableCell>
        <TableCell>{item.dosis}</TableCell>
        <TableCell>{item.posologia}</TableCell>
      </TableRow>
      <TableRow>
      </TableRow>
    </>
  );
}